

import React, { useEffect, useState } from 'react';

import { DashboardLayout, GeneralTable } from "components";

import 'assets/scss/billingPortal/modules/reporting/quarterlyCommission.scss';
import { useCustomSelector } from 'hooks';
import { MultiFilters } from 'components/filters/MultiFilters';
import { useMainReportColumns } from "../hooks/useMainReportColumns";
import { useTableData } from "../hooks/useTableData";
import { isFunction } from 'functions';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import moment from 'moment';
import useUpdateReportingData from '../../useUpdateReportingData';
import { MoreButton } from 'components/buttons/MoreButton';
import ic_update_db from "assets/images/ic_update_db.svg";
import { SubmenuTooltip } from 'components/informational/SubmenuTooltip';


export default function QuarterlyCommission({
    queries,
    setSelectedDealerMonthly: setSelectedDealerMonthly_props,
    setIsMonthlyReportVisible: setIsMonthlyReportVisible_props,
    selectedDealerMonthly,
    setSelectedDate: setSelectedDate_props
}) {
    let setSelectedDealerMonthly = isFunction(setSelectedDealerMonthly_props)? setSelectedDealerMonthly_props: () => {};
    let setIsMonthlyReportVisible = isFunction(setIsMonthlyReportVisible_props)? setIsMonthlyReportVisible_props: () => {};
    let setSelectedDate = isFunction(setSelectedDate_props)? setSelectedDate_props: () => {};

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
		getInvoiceCommissionList_requesting, getCreditNoteCommissionList_requesting
	} = useCustomSelector("reporting");

    const {
        getInvoiceCommissionDrillDownList, getCreditNoteCommissionDrillDownList
    } = useReporting();

    const {
        data, getData, startDate, dealerCode
    } = useTableData({setSelectedDealerMonthly});

    const columns = useMainReportColumns({});

    const {
        updateReportingDataModal,
        setIsModalVisible: setIsModalVisible_reportingData 
    } = useUpdateReportingData();

    return (
        <div className={"quarterly-commission"}>
            <DashboardLayout
                headerTitle={"Dealer Commission Report"}

                bodyClassName={"quarterly-commission__body"}
                body={(
                    <GeneralTable
                        className={"body__table"}
                        lastRowClassName={"last-row"}
                        columns={columns}
                        data={userPermissions?.Internal_DealerReport_View? data: []}

                        onRowClick={(rowDetails) => {
                            setIsMonthlyReportVisible(true);

                            let momentInstance = moment(startDate);
                            momentInstance.add(rowDetails?.index, "month");
                            let month = momentInstance.month() + 1;
                            let year = momentInstance.year();

                            setSelectedDate(momentInstance.format());

                            // Invoice Commissions
                            queries.current = {
                                Year: year,
                                Month: month,
                                agent: selectedDealerMonthly,
                                level1: true
                            };
                        }}

                        outerTableHeader={() => {
                            return (
                                <div className={"table__header"}>
                                    {/* Update Reporting Modal */}
                                    {updateReportingDataModal}

                                    {/* Top Section */}
                                    <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                        {/* Title */}
                                        <div className={"headers__title tableHeaderTitle "}>
                                            Quarterly Commission
                                        </div>

                                        <SubmenuTooltip
                                            menuItems={[
                                                {
                                                    icon: ic_update_db,
                                                    label: "Update Database",
                                                    isDisabled: !(userPermissions?.Internal_DealerReport_Add),
                                                    onClick: () => setIsModalVisible_reportingData(true),
                                                }
                                            ]}
                                        >
                                            <MoreButton
                                                className={"action__more-actions"}
                                                iconClassName={"more-actions__icon"}
                                            />
                                        </SubmenuTooltip>
                                    </div>

                                    {/* Bottom Section */}
                                    <div className={"headers__bottom-section"}>
                                        <MultiFilters
                                            defaultFilterOption={{
                                                label: "Dealer Code",
                                                propertyName: "agent",
                                                placeholder: "Dealer Code",
                                                inputType: "search",
                                            }}
                                            filterOptions={[
                                                {
                                                    label: "Dealer Code",
                                                    propertyName: "agent",
                                                    placeholder: "Dealer Code",
                                                    inputType: "search",
                                                },
                                                {
                                                    label: "Quarter",
                                                    placeholder: "Ex: 2021, Q1",
                                                    propertyName: "date",
                                                    dateOptions: {
                                                        dateFormat: "yyyy, QQQ",
                                                        showQuarterYearPicker: true
                                                    },
                                                    inputType: "date",
                                                }
                                            ]}
                                            dropdownPlaceholder={"Select Filter"}
                                            onApplyFilter={(filters) => {
                                                getData(filters?.agent, filters?.date);
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        }}
                        
                        isTableDataLoading={getInvoiceCommissionList_requesting || getCreditNoteCommissionList_requesting}

                        isUsingPagination

                        isColumnResizeable
                        isTableOddRowsDarken isTableHeightAdjustmentOptional
                    />
                )}
            />
        </div>
    );
}